import React, {useEffect, useState} from 'react';
import {Button, Descriptions, Divider, Flex, Input, message, Modal, Table, Typography} from 'antd';
import ListTable from '../ListTable/ListTable';
import {withRouter} from 'react-router-dom';
import {API} from 'aws-amplify';
import dayjs from 'dayjs';
import {connect} from 'react-redux';
import {EyeOutlined} from '@ant-design/icons';
import {DataStatus} from '../ComponentInfo/Status';

const ClientLogs = ({getColumnSearchProps, clientId}) => {

  const [componentState, setComponentState] = useState({
    data: []
  });

  const [componentInfo, setComponentInfo] = useState({
    tListInfo: {status: DataStatus.Loaded}
  });

  const buildColumns = () => {
    return [
      {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.id - b.id,
        ...getColumnSearchProps({
          dataIndex: 'id',
          render: (text, value) => text
        })
      },
      {
        key: 'recordCreated',
        title: 'Date',
        dataIndex: 'recordCreated',
        ...getColumnSearchProps({
          dataIndex: 'recordCreated',
          filterInputType: 'DATE',
          render: (text, value) => {
            return <span>{`${dayjs(text).format("DD/MM/YYYY")}`}<br />
              {`${dayjs(text).format("HH:mm:ss")}`}
                        </span>

          }
        })
      },
      {
        key: 'logAction',
        title: 'Log Action',
        dataIndex: 'logAction',
        ...getColumnSearchProps({
          dataIndex: 'logAction',
          render: (text, value) => text
        })
      },
      {
        key: 'clientID',
        title: 'Client ID',
        dataIndex: 'clientID',
        ...getColumnSearchProps({
          dataIndex: 'clientID',
          render: (text, value) => text
        })
      },
      {
        key: 'staffID',
        title: 'Staff/Client',
        dataIndex: 'staffID',
        ...getColumnSearchProps({
          dataIndex: 'logAction',
          render: (text, value) => {
            if (value.staffID != null) {
              let staffName = ""
              switch (value.staffID) {
                case 65:
                  staffName = "Admin"
                  break;
                case 102:
                  staffName = "Dion"
                  break;
                case 148:
                  staffName = "Peter"
                  break;
                case 168:
                  staffName = "Jim"
                  break;
                default:
                  staffName = value.staffID
              }
              return <span>Staff: {staffName}</span>
            } else if (value.clientID != null) {
              return <span>Client (ID: {value.clientID})</span>
            }
          }
        })
      },
      {
        key: 'logDescription',
        title: 'Log Text',
        dataIndex: 'logDescription',
        ...getColumnSearchProps({
          dataIndex: 'logDescription',
          render: (text, value) => {
            return text
          }
        })
      },
      {
        key: 'ip',
        title: 'IP',
        dataIndex: 'ip',
        ...getColumnSearchProps({
          dataIndex: 'ip',
          render: (text, value) => {
            switch (text) {
              case '14.201.136.140':
                return <span>{text}<br />FWW Melbourne Office</span>;
              case '103.27.34.129':
                return <span>{text}<br />FWW Backend IP</span>;
              case '182.239.128.74':
                return <span>{text}<br />Jim Office</span>;
              default:
                return text;
            }
          }
        })
      },
      {
        key: 'city',
        title: 'Address',
        dataIndex: 'city',
        ...getColumnSearchProps({
          dataIndex: 'city',
          render: (text, record) => <>
            <Flex justify={'start'} vertical>
              <Typography.Text>City - {record.city}</Typography.Text>
              <Typography.Text>Region - {record.region}</Typography.Text>
              <Typography.Text>Country - {record.country}</Typography.Text>
              <Typography.Text>Location - {record.location}</Typography.Text>
              <Typography.Text>Timezone - {record.timezone}</Typography.Text>
            </Flex>
          </>
        })
      }
    ];
  };

  const fetchLogs = () => {
    const loading = message.loading('Loading client logs. Please wait..', 0);
    setComponentInfo(prev => ({
      ...prev,
      tListInfo: {status: DataStatus.Loading}
    }));
    API.get('logging', `/get-by-client/${clientId}`, {}).then(res => {
      setComponentState({data: res});
      setComponentInfo(prev => ({
        ...prev,
        tListInfo: {status: DataStatus.Loaded}
      }));
    }).catch(() => {
      console.error('Failed to fetch client logs. Please try again...');
    }).finally(() => loading());
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return <>
    <Button type="primary" onClick={fetchLogs} style={{ marginBottom: 16 }}>
      Refresh
    </Button>
    <Table dataSource={componentState.data}
           rowKey={'id'}
           scroll={{x: 'max-content'}}
           expandable={{
             onExpand: (expanded, record) => {
             },
             expandedRowRender: record => {
               return <Flex>
                 <Input.TextArea readonly rows={20} value={JSON.stringify(JSON.parse(record.data), null, 2)} />
               </Flex>;
             }
           }}
           loading={componentInfo.tListInfo.status === DataStatus.Loading}
           columns={buildColumns()}></Table>
  </>;
};

const mapStateToProps = (state) => ({app_state: state.app_state});
const mapDispatchToProps = (state) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListTable(ClientLogs)));